import type { CookieOptions } from '#app'
import { ACCOUNT_NO, ACCESS_TOKEN, REFRESH_TOKEN } from './const'

/** 刪除 Cookie */
export function removeCookie(
  value: string,
  options?: CookieOptions & { readonly?: false }
) {
  if (import.meta.client) {
    useCookie(value, options).value = ''
  }
}

/** 從 Cookies 中刪除 Access Token */
export function removeAccessTokenCookie() {
  removeCookie(ACCESS_TOKEN)
}

/** 從 Cookies 中刪除 Refresh Token */
export function removeRefreshTokenCookie() {
  removeCookie(REFRESH_TOKEN)
}

/** 從 Cookies 中刪除 Account */
export function removeAccountNoCookie() {
  removeCookie(ACCOUNT_NO)
}

/** 從 Cookies 中刪除 accessToken, refreshToken */
export function removeTokenCookies() {
  removeAccessTokenCookie()
  removeRefreshTokenCookie()
}

/** 從 Cookies 中刪除 accessToken, account, refreshToken */
export function removeAuthCookies() {
  removeAccessTokenCookie()
  removeRefreshTokenCookie()
  removeAccountNoCookie()
}
